import { useCallback, useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { useWindowSize } from "../../utils/useWindowSize";

import { Box, Stack, Typography, IconButton, CardMedia, Grid, Skeleton, Dialog } from "@mui/material";

import Toast from "../../utils/Toast";

import { scrapInfoType, userState } from "../../interface/MainInterface";
import { HttpUnAuthApi } from "../../interface/unauth-api";

import BtnNewBoard from "./component/BtnNewBoard";
import CardBtnScrap from "./component/CardBtnScrap";

import "./PopAddScrap.css";

interface propsType {
  userState: userState;
  selectedKeywords: any;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const PopAddScrap = (props: propsType, ref: any) => {
  const toastRef: any = useRef();
  const windowSize = useWindowSize();

  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [briefKeys, setBriefKeys] = useState<any>([]);
  const [scrapList, setScrapList] = useState<any>([]);
  const [selectedScrapInfo, setSelectedScrapInfo] = useState<any>(null);

  useEffect(() => {
    return () => {
      setIsLoading(false);
      setOpenModal(false);
      setBriefKeys([]);
      setScrapList([]);
      setSelectedScrapInfo(null);
    };
  }, []);

  const open = useCallback((list: any) => {
    setBriefKeys(list);
    get_scrap_list();
    setOpenModal(true);
  }, []);

  const close = () => {
    props.callback({ command: "close" });
    setBriefKeys([]);
    setOpenModal(false);
  };

  const get_scrap_list = async () => {
    const param: any = {
      command: "get_scrap_list",
      user_id: props.userState.id,
      sort: "DESCEND",
    };

    setIsLoading(true);
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setSelectedScrapInfo(null);
      setScrapList(res.response.scrap_list);
    }
    setIsLoading(false);
  };

  const update_scrap_info = async (info: scrapInfoType) => {
    // 먼저 confirm을 처리하고, 이후에 비동기 코드 실행 (iOS 18.6.2 버전에서 동작하지 않아서 confirmed 처리)
    const confirmed = window.confirm("선택한 보드에 스크랩 하시겠습니까?");
    if (!confirmed) return;
    // else toastRef.current?.toast("스크랩 되었습니다.", "success", 4000, {vertical: "top", horizontal: "center"});

    let temp: any = [...info.scrap_key_list];
    for (const key of briefKeys) {
      const keys = key.split('/');

      // 이미 담겨있는 스크랩인지 체크
      // const exists = temp.some((item: any) => item.pk === keys[0] && item.sk === keys[1] && item.keyword == props.selectedKeywords);
      const exists = temp.some((item: any) => item.show_pk === keys[0] && item.sk === keys[1]);
      if (exists){
        continue;
      }

      // for (const keyword of props.selectedKeywords) {
        // temp.push({"pk": keys[0], "sk": keys[1], "keyword": keyword});
      // }
      temp.push({"show_pk": keys[0], "sk": keys[1]});
    }
    info.scrap_key_list = temp;

    // 키워드 중복제거 후 추가
    let keys: any = info.selectedKeywords ? [...info.selectedKeywords] : [];

    for (const key of props.selectedKeywords) {
      if (keys.indexOf(key) < 0) {
        keys.push(key);
      }
    }

    const param: any = {
      command: "update_scrap_info2",
      scrap_info: info,
      selectedKeywords: keys,
      user_id: props.userState.id,
    };

    setIsLoading(true);
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      get_scrap_list();
    } else {
      toastRef.current?.toast("에러가 발생했습니다.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    }
    setIsLoading(false);
  };

  // const update_scrap_info_previous = async (info: scrapInfoType) => {
  //   if (!window.confirm("선택한 보드에 스크랩 하시겠습니까?")) return;

  //   console.log(info);
  //   let temp: any = [...info.scrap_key_list];
  //   // 중복 제거 후 추가
  //   for (const key of briefKeys) {
  //     if (temp.indexOf(key) < 0) {
  //       temp.push(key);
  //     }
  //   }
  //   info.scrap_key_list = temp;

  //   // 키워드 중복제거 후 추가
  //   let keys: any = info.selectedKeywords ? [...info.selectedKeywords] : [];

  //   for (const key of props.selectedKeywords) {
  //     if (keys.indexOf(key) < 0) {
  //       keys.push(key);
  //     }
  //   }

  //   const param: any = {
  //     command: "update_scrap_info",
  //     scrap_info: info,
  //     selectedKeywords: keys,
  //     user_id: props.userState.id,
  //   };

  //   setIsLoading(true);
  //   const res = await unAuthAPI.post(param);
  //   if (res.code === "200") {
  //     get_scrap_list();
  //   } else {
  //     toastRef.current?.toast("에러가 발생했습니다.", "error", 4000, {
  //       vertical: "top",
  //       horizontal: "center",
  //     });
  //   }
  //   setIsLoading(false);
  // };

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    open,
  }));

  return (
    <>
      <Dialog
        open={openModal}
        onClose={close}
        PaperProps={{
          style: {
            width: "100%",
            maxWidth: "1000px",
            background: "#ffffff",
            borderRadius: "30px",
          },
        }}
      >
        <Box className="scrap-modal">
          <Box className="header">
            <Box className="title">
              <Typography className="text">{"스크랩보드 리스트"}</Typography>
            </Box>
            <Box className="btn">
              <IconButton
                onClick={() => {
                  close();
                }}
              >
                <CardMedia component={"img"} image="/images/icon-close-m-blk.png" sx={{ height: "22px" }} />
              </IconButton>
            </Box>
          </Box>
          <Box className="title-margin"></Box>
          <Box className="content noScrollBar" sx={{ maxHeight: `${windowSize.height - 350}px` }}>
            <Stack direction={"column"} spacing={0}>
              <Grid container spacing={2}>
                {/* 새로운 보드 생성 버튼 영역 */}
                <Grid item xs={12} md={12} lg={6} xl={6}>
                  <BtnNewBoard
                    userState={props.userState}
                    callback={(payload: any) => {
                      if (payload.command === "finish_create_new_scrap") get_scrap_list();
                    }}
                  />
                </Grid>
                {isLoading && scrapList.length < 1
                  ? [...Array(3)].map((value: any, index) => (
                      <Grid key={`scrap-${index}`} item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Skeleton
                          key={`scrap-${index}`}
                          variant="rounded"
                          width={"100%"}
                          height={windowSize.width > 1023 ? "153px" : "123px"}
                          sx={{ borderRadius: "30px" }}
                        />
                      </Grid>
                    ))
                  : scrapList.map(
                      (scrapInfo: any, index: number) =>
                        (
                          <Grid key={`scrap-${index}`} item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <CardBtnScrap
                              userState={props.userState}
                              scrapInfo={scrapInfo}
                              selectedScrapInfo={selectedScrapInfo}
                              callback={(payload: any) => {
                                if (payload.command === "select_scrap_info") {
                                  setSelectedScrapInfo(payload.value);
                                } else if (payload.command === "finish_delete_scrap_info") {
                                  get_scrap_list();
                                } else if (payload.command === "update_title") {
                                  get_scrap_list();
                                }
                              }}
                            />
                          </Grid>
                        )
                    )}
              </Grid>
            </Stack>
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", p: "24px" }}>
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            className={selectedScrapInfo ? "btn-add-scrap add-scrap-able" : "btn-add-scrap"}
          >
            <button
              onClick={() => {
                if (selectedScrapInfo) {
                  update_scrap_info(selectedScrapInfo);
                }
              }}
            >
              <i>
                <span>선택한 보드에 스크랩</span>
              </i>
            </button>
          </Box>
        </Box>
      </Dialog>
      <Toast ref={toastRef} />
    </>
  );
};

export default forwardRef(PopAddScrap);
